import { Directive, TemplateRef, input, output, contentChild } from '@angular/core';
import { DatatableRowDetailTemplateDirective } from './row-detail-template.directive';

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: 'ngx-datatable-row-detail'
})
export class DatatableRowDetailDirective {
  /**
   * The detail row height is required especially
   * when virtual scroll is enabled.
   */
  readonly rowHeight = input<number | 'auto' | ((row?: unknown, index?: number) => number)>(0);

  readonly _templateInput = input<TemplateRef<unknown>>(undefined, { alias: 'template' });

  readonly _templateQuery = contentChild(DatatableRowDetailTemplateDirective, { read: TemplateRef });

  get template(): TemplateRef<unknown> {
    return this._templateInput() || this._templateQuery();
  }

  /**
   * Row detail row visbility was toggled.
   */
  readonly toggle = output<unknown>();

  /**
   * Toggle the expansion of the row
   */
  toggleExpandRow(row: unknown): void {
    this.toggle.emit({
      type: 'row',
      value: row
    });
  }

  /**
   * API method to expand all the rows.
   */
  expandAllRows(): void {
    this.toggle.emit({
      type: 'all',
      value: true
    });
  }

  /**
   * API method to collapse all the rows.
   */
  collapseAllRows(): void {
    this.toggle.emit({
      type: 'all',
      value: false
    });
  }
}
